import React, { useState, useEffect, useRef } from "react";
import { setPromptRequest, setReferImageSrc, uploadImage } from "../../../models/generateSlice";
import { useDispatch, useSelector } from "react-redux";
import ImageUploaderView from "./ImageUploaderView";

const ImageUploader = () => {
  const [file, setFile] = useState(null);

  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const imageSrc = useSelector((state) => state.generate.referImageSrc);
  const imageUploadStatus = useSelector((state) => state.generate.imageUploadStatus);
  const filename = useSelector((state) => state.generate.promptRequest.filename);
  const setInfluence = (value) => {
    dispatch(setPromptRequest({ influence: value }));
  };

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        dispatch(setReferImageSrc(e.target.result));
      };
      reader.readAsDataURL(file);

      // 上传文件
      dispatch(uploadImage(file));
    }
  }, [file, dispatch]);

  const handleFileChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      setFile(newFile);
      dispatch(setPromptRequest({ filename: newFile.name }));
    }
  };

  const handleDeleteReferImage = () => {
    setFile(null); // Reset file state
    dispatch(setReferImageSrc(""));
    dispatch(setPromptRequest({ filename: "" }));
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clear file input
    }
  };

  return <ImageUploaderView filename={filename} fileInputRef={fileInputRef} imageSrc={imageSrc} imageUploadStatus={imageUploadStatus} handleFileChange={handleFileChange} setInfluence={setInfluence} deleteReferImage={handleDeleteReferImage} />;
};

export default ImageUploader;
